import {
  CONFIRMED_GET_MONTHLY_TARGET,
  CONFIRMED_SAVE_MONTHLY_TARGET,
  CONFIRMED_DELETE_MONTHLY_TARGET,
} from "../types/MonthlyTargetTypes";

import {
  getMonthlyTargets,
  addOrUpdateMonthlyTarget,
  deleteMonthlyTarget,
} from "../../services/MonthlyTargetService";

import {
  handleSuccess,
  showErrorAlert,
} from "../../services/ErrorHandlingService";

/* =============================
   GET
============================= */
export function getMonthlyTargetAction(month, year) {
  return async (dispatch) => {
    try {
      const response = await getMonthlyTargets(month, year);

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_MONTHLY_TARGET,
          payload: response.data.data || [],
        });
        return { success: true, data: response.data.data };
      } else {
        showErrorAlert(response?.data?.message || "Failed to fetch monthly target");
        dispatch({
          type: CONFIRMED_GET_MONTHLY_TARGET,
          payload: [],
        });
        return { success: false };
      }
    } catch (error) {
      console.error("Get monthly target error:", error);
      showErrorAlert(error.response?.data?.message || "Something went wrong");
      dispatch({
        type: CONFIRMED_GET_MONTHLY_TARGET,
        payload: [],
      });
      return { success: false };
    }
  };
}

/* =============================
   SAVE
============================= */
export function saveMonthlyTargetAction(data) {
  return async (dispatch) => {
    try {
      const response = await addOrUpdateMonthlyTarget(data);

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_SAVE_MONTHLY_TARGET,
          payload: response.data.data,
        });

        handleSuccess(response.data?.message || "Monthly target saved successfully!");
        return { success: true, data: response.data.data };
      } else {
        showErrorAlert(response.data?.message || "Failed to save monthly target");
        return { success: false };
      }
    } catch (error) {
      console.error("Save monthly target error:", error);
      showErrorAlert(error.response?.data?.message || "Failed to save monthly target");
      return { success: false };
    }
  };
}

/* =============================
   DELETE
============================= */
export function deleteMonthlyTargetAction(target_id) {
  return async (dispatch) => {
    try {
      const response = await deleteMonthlyTarget(target_id);

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_DELETE_MONTHLY_TARGET,
          payload: target_id,
        });

        handleSuccess(response.data?.message || "Monthly target deleted successfully!");
        return { success: true };
      } else {
        showErrorAlert(response.data?.message || "Failed to delete monthly target");
        return { success: false };
      }
    } catch (error) {
      console.error("Delete monthly target error:", error);
      showErrorAlert(error.response?.data?.message || "Failed to delete monthly target");
      return { success: false };
    }
  };
}